import React from "react";
import { getGuideCardIcon } from "../../constants/guideCardIcons.js";

export const GuideSectionLabel = ({ children }) => (
  <p className="guide-block__label">{children}</p>
);

export const GuideLead = ({ children }) => <p className="guide-block__lead">{children}</p>;

export const GuideCallout = ({ children, variant = "default" }) => (
  <blockquote className={`guide-block__callout guide-block__callout--${variant}`}>{children}</blockquote>
);

export const GuideCompare = ({ leftTitle, rightTitle, left, right }) => (
  <div className="guide-block__compare">
    <div className="guide-block__compare-col">
      <h3 className="guide-block__compare-title">{leftTitle}</h3>
      <div className="guide-block__compare-body">{left}</div>
    </div>
    <div className="guide-block__compare-col guide-block__compare-col--accent">
      <h3 className="guide-block__compare-title">{rightTitle}</h3>
      <div className="guide-block__compare-body">{right}</div>
    </div>
  </div>
);

export const GuideCard = ({ icon, iconKey, iconSrc, title, description, children, variant }) => {
  const resolvedIconSrc = iconSrc || (iconKey ? getGuideCardIcon(iconKey) : null);
  const cardClass = variant ? `guide-block__card guide-block__card--${variant}` : "guide-block__card";

  return (
    <article className={cardClass}>
      {resolvedIconSrc ? (
        <img src={resolvedIconSrc} alt="" className="guide-block__card-icon-img" aria-hidden="true" />
      ) : icon ? (
        <span className="guide-block__card-icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <h3 className="guide-block__card-title">{title}</h3>
      {description ? <p className="guide-block__card-desc">{description}</p> : null}
      {children}
    </article>
  );
};

export const GuideCardGrid = ({ columns = 2, children }) => (
  <div className={`guide-block__grid guide-block__grid--${columns}`}>{children}</div>
);

export const GuidePillar = ({ title, children }) => (
  <div className="guide-block__pillar">
    <h3 className="guide-block__pillar-title">{title}</h3>
    <div className="guide-block__pillar-body">{children}</div>
  </div>
);

export const GuidePillarGrid = ({ columns = 3, children }) => (
  <div className={`guide-block__pillar-grid guide-block__pillar-grid--${columns}`}>{children}</div>
);

export const GuideContrast = ({ items }) => (
  <div className="guide-block__contrast">
    {items.map((item) => (
      <div key={item.title} className="guide-block__contrast-item">
        <h3 className="guide-block__contrast-title">{item.title}</h3>
        <p className="guide-block__contrast-text">{item.text}</p>
      </div>
    ))}
  </div>
);

export const GuideBlockList = ({ items }) => (
  <ul className="guide-block__list">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);
